
import { initQuarterlyFinancialResults } from "./../js/quarterlyFinancialResults/initQuarterlyFinancialResults";

initQuarterlyFinancialResults("quarterly-financial-results");
